<template>
  <main v-if="service">
    <section class="section service-hero" :style="heroStyle">
      <div class="shell">
        <header class="page-head compact">
          <h1>{{ service.title }}</h1>
        </header>
      </div>
    </section>

    <section class="section">
      <div class="shell detail-grid">
        <article class="card panel detail-content">
          <p v-for="(paragraph, index) in service.paragraphs" :key="index">{{ paragraph }}</p>
        </article>

        <aside class="card panel sidebar">
          <h2>Service Hours</h2>
          <ul>
            <li v-for="item in serviceHours" :key="item.day">
              <span>{{ item.day }}</span>
              <strong>{{ item.hours }}</strong>
            </li>
          </ul>
          <router-link class="btn btn-primary" to="/services-request">Schedule now</router-link>
        </aside>
      </div>
    </section>
  </main>

  <NotFoundView v-else />
</template>

<script>
import { services, serviceHours } from '@/data/content';
import NotFoundView from '@/views/NotFoundView.vue';

export default {
  components: { NotFoundView },
  computed: {
    service() {
      return services.find((entry) => entry.slug === this.$route.params.slug);
    },
    heroStyle() {
      return {
        backgroundImage: `linear-gradient(120deg, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.5)), url('${this.service.cover}')`,
      };
    },
    serviceHours() {
      return serviceHours;
    },
  },
};
</script>

<style scoped>
.service-hero {
  min-height: 40vh;
  display: grid;
  align-items: end;
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid var(--orange);
}

.compact {
  margin-bottom: 0;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1.4fr 0.8fr;
  gap: 1rem;
}

.detail-content {
  display: grid;
  gap: 0.9rem;
}

.detail-content p {
  color: var(--white);
}

.sidebar {
  height: fit-content;
}

.sidebar h2 {
  font-size: var(--h3);
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 1rem 0;
  display: grid;
  gap: 0.6rem;
}

.sidebar li {
  display: flex;
  justify-content: space-between;
  gap: 0.7rem;
  color: var(--white);
}

.sidebar strong {
  color: var(--orange);
}

@media (max-width: 860px) {
  .detail-grid {
    grid-template-columns: 1fr;
  }
}
</style>
